import http from "../../../../plugins/http-common"
import { DetailedStockEntity } from "../../domain/entities/detailed_stock_entity";

export const HttpDetailedStockRepository = {
    model: DetailedStockEntity,

    async update_product_detailed_stock(detail_id, detail_order_data) {
        const res = await http.patch('products/adjust/stock/' + detail_id, detail_order_data);
        
        return res;
    },
    
}